// // Provider Action Types

// Custom View Action Types - start
export const GET_ALL_CUSTOM_VIEWS_REQUEST = 'GET_ALL_CUSTOM_VIEWS_REQUEST';
export const GET_ALL_CUSTOM_VIEWS_SUCCESS = 'GET_ALL_CUSTOM_VIEWS_SUCCESS';
export const GET_ALL_CUSTOM_VIEWS_FAILURE = 'GET_ALL_CUSTOM_VIEWS_FAILURE';

export const GET_CUSTOM_VIEW_FIELDS_REQUEST = 'GET_CUSTOM_VIEW_FIELDS_REQUEST';
export const GET_CUSTOM_VIEW_FIELDS_SUCCESS = 'GET_CUSTOM_VIEW_FIELDS_SUCCESS';
export const GET_CUSTOM_VIEW_FIELDS_FAILURE = 'GET_CUSTOM_VIEW_FIELDS_FAILURE';

export const SAVE_CUSTOM_VIEW_FIELDS_REQUEST = 'SAVE_CUSTOM_VIEW_FIELDS_REQUEST';
export const SAVE_CUSTOM_VIEW_FIELDS_SUCCESS = 'SAVE_CUSTOM_VIEW_FIELDS_SUCCESS';
export const SAVE_CUSTOM_VIEW_FIELDS_FAILURE = 'SAVE_CUSTOM_VIEW_FIELDS_FAILURE';
// Custom View Action Types - end


export const UPDATE_RAD_REDUCER = 'UPDATE_RAD_REDUCER';
